import { api } from 'shared';
import { SNAPSHOT_URL } from 'shared/api/axios';

import { SaveKycReq } from '../model';

const getIsKycApproved = (address: string) => {
  return api<{ isKycApproved: boolean }>({
    url: '/user/approved',
    params: { address },
    method: 'GET',
  });
};

const saveKyc = (data: SaveKycReq) => {
  return api({
    url: '/user',
    data,
    method: 'POST',
  });
};

const getAirdropInfo = (address: string) => {
  return api({
    url: `/merkleairdrop/${address}/`,
    method: 'GET',
    baseURL: SNAPSHOT_URL,
  });
};

export const userApi = {
  getIsKycApproved,
  saveKyc,
  getAirdropInfo,
};
